import React from 'react';
import { Link } from 'react-router-dom'; // Ensure your project uses react-router-dom
import LostItemFunctions from '../../LostItem/LostItemFunctions';

function formatItemStatusCell(item){
    let statusText= LostItemFunctions.itemStatusDesc(item.itemState);
    if (item.itemState==='C' || item.itemState==='R'){
        return(<p className="text-success"><b>{statusText}</b></p>);
    }else if(item.itemState==='Q'){
        return(<p className="text-info"><b>{statusText}</b></p>);
    }else{
        return(<p className="text-primary"><b>{statusText}</b></p>);
    }
  };

const FoundItemsGrid = ({ foundItems, showMagCallBack }) => {
  return (
    <div className="container-fluid">
      <div className="row">
        {foundItems.map(item => (
          <div
            key={item._id}
            className="col-12 col-md-6 col-lg-3 d-flex align-items-stretch mb-4"
          >
            {/* Card size set to roughly 500x500 */}
            <div className="card" style={{ width: '700px', height: '550px' }}>
              {/* Card header with title */}
              <div className="card-header">
                <h5 className="card-title">{item.shortDescription}</h5>
              </div>

              {/* Image area; using objectFit to ensure the image covers its space */}
              <img
                src={item.url}
                className="card-img-top"
                alt={item.shortDescription}
                loading="lazy"
                onClick={() => {if (showMagCallBack){ showMagCallBack(item.url)}}} // Add a click handler if needed
                style={{
                  height: '250px',
                  objectFit: 'cover'
                }}
              />

              {/* Table area for additional details */}
              <div className="card-body p-1">
                <div className="row">
                    <div className="col-4">Description:</div>
                    <div className="col-8">{item.longDescription}</div>
                </div>
                <div className="row">
                    <div className="col-4">Found Date:</div>
                    <div className="col-8">{new Date(item.foundDate).toLocaleString()}</div>
                </div>
                <div className="row">
                    <div className="col-4">Location:</div>
                    <div className="col-8">{item.locationName}</div>
                </div>
                <div className="row">
                    <div className="col-4">Found By:</div>
                    <div className="col-8">{item.foundByName}</div>
                </div>
                <div className="row">
                    <div className="col-4">Storage:</div>
                    <div className="col-8">{item.storageLocation}</div>
                </div>
                <div className="row">
                    <div className="col-4">Status:</div>
                    <div className="col-8">{formatItemStatusCell(item)}</div>
                </div>
                
              </div>

              {/* Footer with the details button */}
              <div className="card-footer text-center">
                <Link to={`/LostItem/${item._id}`} className="btn btn-sm btn-dark">
                  Details
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FoundItemsGrid;